//App.js

import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';

// --- IMPORTAÇÃO DAS PÁGINAS ---
import Login from './pages/Login';
import Dashboard from './pages/Dashboard'; // Painel Master (Você)
import MinhaLoja from './pages/MinhaLoja'; // Painel do Lojista (Pedidos/Operação)
import EditorCardapio from './pages/EditorCardapio';
import Produtos from './pages/Produtos';
import Categorias from './pages/Categorias';
import Adicionais from './pages/Adicionais';
import PreviewCardapio from './pages/PreviewCardapio';
import PublicView from './pages/PublicView'; // O Cardápio que o cliente vê

// --- IMPORTAÇÃO DO COMPONENTE DE LOGÍSTICA (PÚBLICO) ---
import AcompanharPedido from './pages/MinhaLoja/AcompanharPedido';

// --- COMPONENTE DE PROTEÇÃO DE ROTA (GATEKEEPER) ---
const PrivateRoute = ({ children, allowedRoles }) => {
  const token = localStorage.getItem('token');
  const userRole = localStorage.getItem('userRole'); 
  
  // Tratamento rigoroso: Converte strings textuais "null" ou "undefined" em null de verdade
  const rawEstabId = localStorage.getItem('estabelecimentoId');
  const estabId = (!rawEstabId || rawEstabId === 'null' || rawEstabId === 'undefined' || rawEstabId === '') ? null : rawEstabId;
  
  const location = useLocation();

  if (!token) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  // Tratamento específico e seguro para a rota do painel master (/dashboard)
  if (location.pathname === '/dashboard') {
    if (userRole === 'admin_master' && !estabId) {
      return children;
    } else {
      return <Navigate to="/minha-loja" replace />;
    }
  }

  // Verifica se o cargo do usuário está na lista de permitidos
  if (allowedRoles && !allowedRoles.includes(userRole)) {
    const redirectPath = (userRole === 'admin_master' && !estabId) ? '/dashboard' : '/minha-loja';
    return <Navigate to={redirectPath} replace />;
  }

  return children;
};

function App() {
  return (
    <Router>
      <Routes>
        {/* ======================================================
            1. ACESSO ADMINISTRATIVO (LOGIN)
        ====================================================== */}
        <Route path="/" element={<Login />} />

        {/* ======================================================
            2. ROTA DO GESTOR DA PLATAFORMA (ADMIN MASTER)
        ====================================================== */}
        <Route 
          path="/dashboard" 
          element={
            <PrivateRoute allowedRoles={['admin_master']}>
              <Dashboard />
            </PrivateRoute>
          } 
        />

        {/* ======================================================
            3. ROTA DO ESTABELECIMENTO (PAINEL DO LOJISTA)
        ====================================================== */}
        <Route 
          path="/minha-loja" 
          element={
            <PrivateRoute allowedRoles={['admin', 'gerente', 'funcionario', 'admin_master']}>
              <MinhaLoja />
            </PrivateRoute>
          } 
        />

        {/* ======================================================
            4. FERRAMENTAS DE EDIÇÃO E CONFIGURAÇÃO
        ====================================================== */}
        <Route 
          path="/produtos/:id" 
          element={
            <PrivateRoute allowedRoles={['admin', 'gerente', 'admin_master']}>
              <Produtos />
            </PrivateRoute>
          } 
        />

        <Route 
          path="/categorias/:id" 
          element={
            <PrivateRoute allowedRoles={['admin', 'gerente', 'admin_master']}>
              <Categorias />
            </PrivateRoute>
          } 
        />

        <Route 
          path="/adicionais/:id" 
          element={
            <PrivateRoute allowedRoles={['admin', 'gerente', 'admin_master']}>
              <Adicionais />
            </PrivateRoute>
          } 
        />

        <Route 
          path="/editor/:id" 
          element={
            <PrivateRoute allowedRoles={['admin', 'gerente', 'admin_master']}>
              <EditorCardapio />
            </PrivateRoute>
          } 
        />

        <Route 
          path="/preview/:id" 
          element={
            <PrivateRoute allowedRoles={['admin', 'gerente', 'funcionario', 'admin_master']}>
              <PreviewCardapio />
            </PrivateRoute>
          } 
        />

        {/* ======================================================
            5. RASTREAMENTO DE PEDIDO (PÚBLICO - iFood Style)
        ====================================================== */}
        <Route path="/rastreio/:pedidoId" element={<AcompanharPedido />} />

        {/* ======================================================
            6. ÁREA DO CLIENTE FINAL (HISTÓRICO DE PEDIDOS)
        ====================================================== */}
        <Route path="/:slug/meus-pedidos" element={<PublicView forceView="cliente" />} />

        {/* ======================================================
            7. CARDÁPIO PÚBLICO (CLIENTE FINAL)
        ====================================================== */}
        <Route path="/:slug" element={<PublicView />} />

        {/* FALLBACK: REDIRECIONA PARA LOGIN SE A ROTA NÃO EXISTIR */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;